if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"overtur","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(264|41|567|797|822)|2(69[57]|(01|32|38)7|203|715)|3(033|29|421|87)|4(041|15|733|765)|5([09]97|(15|71|82)9|076|381|41|602|770|808|963)|6(5(25|31|87|91)|(00|33|68|74)1|037|35|699|757)|7((30|33|96)7|269|598|729|813)|8(09(|9)|57[13]|131|609|611|955)|9198|9353)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}